// BooleanField.jsx
import { Box, Typography, Autocomplete, TextField } from "@mui/material";
import { formatTitle } from "../utils";

export const BooleanField = ({
  fieldKey,
  schema,
  value,
  required,
  onChange,
}) => {
  const options = [
    { label: "Yes", value: true },
    { label: "No", value: false },
  ];

  return (
    <Box>
      <Autocomplete
        options={options}
        value={options.find((opt) => opt.value === value) || null}
        onChange={(e, newValue) => {
          onChange(newValue?.value ?? false);
        }}
        getOptionLabel={(option) => option.label}
        isOptionEqualToValue={(opt, val) => opt.value === val.value}
        renderInput={(params) => (
          <TextField
            {...params}
            label={schema?.title || formatTitle(fieldKey)}
            required={required}
            size="small"
            fullWidth
          />
        )}
      />
    </Box>
  );
};
